/**
 * Fixed Phone retail purchase flow feature flags.
 * Toggle multi-line checkout here when the product supports multiple lines per order.
 */
export const FIXED_PHONE_MULTI_LINE_CHECKOUT_ENABLED = false;

export function isFixedPhoneMultiLineCheckoutEnabled(): boolean {
  return FIXED_PHONE_MULTI_LINE_CHECKOUT_ENABLED;
}
